import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { Input, Directive, HostListener } from '@angular/core';

import { PopupComponent } from './popup.component';

@Directive({
  selector: '[sondermindPopupTrigger]',
  standalone: false
})
export class PopupTriggerDirective extends CdkOverlayOrigin {
  @Input() popup: PopupComponent;

  @HostListener('click') onClick() {
    this.popup.origin = this;
    this.popup.changeState();
  }
}
